import { withPrefix } from "gatsby";

export const submitData = async (formData, captcha, privacyData, formType) => {
  const {
    brand,
    websiteSource,
    country,
    language,
    leadSource,
    status,
    isTestRecord,
    campaign,
    campaignSource,
  } = privacyData;
  const path = withPrefix("/");
  const body = {
    ...formData,
    brand: brand?.length ? brand[0] : null,
    websiteSource: websiteSource?.length ? websiteSource?.[0] : null,
    isoCode: country?.length ? country?.[0] : null,
    language: language?.length ? language?.[0] : null,
    origin: (leadSource?.length ? leadSource?.[0] : null) || "Web",
    status: isTestRecord?.length ? status?.[0] : null,
    isTestRecord: isTestRecord?.length && isTestRecord?.[0] === "true" ? "1" : "0",
    campaign: campaign?.length ? campaign?.[0] : null,
    campaignSource: campaignSource?.length ? campaignSource?.[0] : null,
    locale: path.substring(1, path?.length - 1),
  };
  console.log("About to submit: ", body);

  const response = await fetch(`/headless-api/form/submit`, {
    method: "POST",
    body: JSON.stringify({ formData: body, captcha, tipology: formType }),
  });
  console.log("response: ", response);
  if (response.ok) {
    const result = await response.json();
    return result;
  } else {
    throw new Error(response.statusText);
  }
};

export const getPrivacyData = (data) => {
  const privacy1Value = data.privacyText.privacy1FieldSet?.privacy1Default?.[0] === "checked";
  const privacy2Value = data.privacyText.privacy2FieldSet?.privacy2Default;
  const privacy3Value = data.privacyText?.privacy3FieldSet?.privacy3Default;
  return {
    privacy1: privacy1Value,
    privacy2: !!privacy2Value?.length ? (privacy2Value?.[0] === "yes" ? "true" : "false") : "",
    privacy3: !!privacy3Value?.length ? (privacy3Value?.[0] === "yes" ? "true" : "false") : "",
  };
};
